import { useMemo } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import __ from "src/utils/Translations";
import { IGroupedWaitingRoom } from "src/Pages/Company/Pending/PendingBenefits/types";
import { WaitingRoomRow } from "./WaitingRoomRow";
import {
  CellHeaderSeparatorStyle,
  CellWithDividerStyle,
  TableBodyStyle,
  TableContainerStyle,
} from "./TableStyles";
import { SalaryDeductionRow } from "./SalaryDeductionRow";
import { moveChildrenUnderParents } from "./utils";

interface PendingBenefitsDetailsProps {
  row: IGroupedWaitingRoom;
}
export const PendingBenefitsDetails = ({
  row,
}: PendingBenefitsDetailsProps) => {
  const { waitingRoomsGroup } = row;

  const singleWaitingRooms = useMemo(
    () => moveChildrenUnderParents(row.singleWaitingRooms),
    [row.singleWaitingRooms]
  );

  const groupedWaitingRooms = useMemo(
    () =>
      waitingRoomsGroup && waitingRoomsGroup.waitingRooms.length > 0
        ? moveChildrenUnderParents(waitingRoomsGroup.waitingRooms)
        : [],
    [waitingRoomsGroup]
  );

  if (!waitingRoomsGroup && !singleWaitingRooms.length) {
    return (
      <Typography
        variant="body2"
        color="textSecondary"
        align="center"
        sx={{ p: 2 }}
      >
        {__("Brak dostępnych benefitów")}
      </Typography>
    );
  }

  return (
    <TableContainer sx={TableContainerStyle}>
      <Table aria-label={__("Szczegóły benefitów")}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ paddingLeft: "24px" }} />
            <TableCell sx={CellWithDividerStyle}>{__("Produkt")}</TableCell>
            <TableCell sx={CellWithDividerStyle}>
              {__("Data zamówienia")}
            </TableCell>
            <TableCell align="right" sx={CellWithDividerStyle}>
              {__("Łączny koszt")}
            </TableCell>
            <TableCell align="right" sx={CellWithDividerStyle}>
              {__("Opłacane przez pracownika")}
            </TableCell>
            <TableCell sx={CellWithDividerStyle}>{__("Status")}</TableCell>
            <TableCell sx={{ paddingRight: "24px" }}>
              {__("Akcje na produkcie")}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody sx={TableBodyStyle}>
          {singleWaitingRooms.length > 0 && (
            <>
              <TableRow>
                {/* 7 columns: checkbox, product, date, total cost, employee paid, status, actions */}
                <TableCell colSpan={7} sx={CellHeaderSeparatorStyle}>
                  <Typography variant="body2" color="textSecondary">
                    {__("Zamówienia bez potrącenia z wynagrodzenia")}
                  </Typography>
                </TableCell>
              </TableRow>
              {singleWaitingRooms.map((item) => (
                <WaitingRoomRow
                  key={`single-${item.id}`}
                  waitingRoom={item}
                  conditions={item.conditions}
                />
              ))}
            </>
          )}
          {waitingRoomsGroup && waitingRoomsGroup.waitingRooms.length > 0 && (
            <>
              <TableRow>
                {/* 7 columns: checkbox, product, date, total cost, employee paid, status, actions */}
                <TableCell colSpan={7} sx={CellHeaderSeparatorStyle}>
                  <Typography variant="body2" color="textSecondary">
                    {__("Zamówienia z potrąceniem z wynagrodzenia")}
                  </Typography>
                </TableCell>
              </TableRow>
              <SalaryDeductionRow waitingRoomsGroup={waitingRoomsGroup} />
              {groupedWaitingRooms.map((item) => (
                <WaitingRoomRow
                  key={`grouped-${item.id}`}
                  waitingRoom={item}
                  conditions={item.conditions}
                />
              ))}
            </>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
